// eslint-disable-next-line import/no-anonymous-default-export
export default (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
